import { createSelector } from '@reduxjs/toolkit'
import { getCollectionOrEmptyObject } from '@opallabs/lambda'
import { getBrandId, getBrands } from '../../getters/entities/brands'

export const selectCurrentBrand = createSelector(
  [getBrandId, getBrands],
  (brandId, brands) => {
    if (!brandId || !brands) return null
    return brands[brandId]
  }
)

export const selectCurrentBrandId = createSelector(
  [getBrandId],
  (brandId) => brandId
)

export const selectBrands = createSelector([getBrands], (brands) =>
  getCollectionOrEmptyObject(brands)
)
